import styled, { css } from 'styled-components';
import { styles } from '../constants/styles.js';
import { boxStyles } from '../Box/styles.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { getButtonStyles } from './utils.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';
import { px2rem, inPixels } from '../utils/helpers/style.js';
import { themeVariant } from '../utils/helpers/themeVariant.web.js';

var buttonPaddings = /*#__PURE__*/css(["", ""], function (_ref) {
  var theme = _ref.theme,
    status = _ref.$status,
    variant = _ref.$variant,
    size = _ref.$size;
  var buttonTheme = theme.button.web;
  var fromSide = inPixels(variant === 'condensed' ? buttonTheme.paddings.horizontal.condensed : buttonTheme.paddings.horizontal[size]);
  var borderWidth = status === 'plain' ? inPixels(0) : inPixels(buttonTheme.borders.width);
  return css(["padding-top:", ";padding-bottom:", ";padding-left:calc(", " - ", ");padding-right:calc(", " - ", ");"], typeof buttonTheme.paddings.top === 'number' ? inPixels(buttonTheme.paddings.top) : buttonTheme.paddings.top, typeof buttonTheme.paddings.bottom === 'number' ? inPixels(buttonTheme.paddings.bottom) : buttonTheme.paddings.bottom, fromSide, borderWidth, fromSide, borderWidth);
});
var baseButtonStyles = /*#__PURE__*/css(["text-decoration:none;-webkit-appearance:none;-webkit-tap-highlight-color:rgba(0 0 0 0%);outline:none;border:none;::-moz-focus-inner{border:none;}box-sizing:border-box;", " transition:background ", ",color ", ",border ", ";transition-timing-function:", ";", ""], getButtonStyles('normal'), styles.transition.timing.base, styles.transition.timing.base, styles.transition.timing.base, styles.transition["function"].base, function (props) {
  return props.disabled ? css(["", " cursor:not-allowed;"], getButtonStyles('disabled')) : css(["@media (hover:hover){&:hover{", " cursor:pointer;}}&:focus-visible{box-shadow:0 0 0 4px ", ";outline:2px solid ", ";outline-offset:0;}&:focus{", "}&:active{", " transition:unset;}"], getButtonStyles('hover'), function (p) {
    return p.theme.tokens.focus.primary;
  }, function (p) {
    return p.theme.tokens.focus.secondary;
  }, getButtonStyles('focus'), getButtonStyles('click'));
});
var text = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__text",
  componentId: "sc-1vj6sky-0"
})(["display:inline-block;margin-top:", ";"], function (props) {
  return px2rem(props.theme.button.web.margins.text.top);
});
var buttonTextStyles = /*#__PURE__*/css(["text-align:", ";padding-left:", ";padding-right:", ";"], function (props) {
  return props.textAlign ? props.textAlign : 'center';
}, themeVariant({
  normal: function normal(props) {
    return props.$withLeftIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  },
  condensed: function condensed(props) {
    return props.$withLeftIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  }
}), themeVariant({
  normal: function normal(props) {
    return props.$withRightIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  },
  condensed: function condensed(props) {
    return props.$withRightIcon ? px2rem(props.theme.button.web.paddings.afterIcon) : 0;
  }
}));
var buttonFixedStyle = /*#__PURE__*/css(["height:", ";"], themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.button.web.height[props.$size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.button.web.height.condensed);
  }
}));
var buttonResizeStyle = /*#__PURE__*/css(["height:auto;min-height:", ";align-items:", ";padding-block:", ";"], themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.button.web.height[props.$size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.button.web.height.condensed);
  }
}), function (p) {
  return p.theme.button.web.autoResize.alignContent;
}, function (p) {
  return typeof p.theme.button.web.autoResize.paddingBlock === 'number' ? inPixels(p.theme.button.web.autoResize.paddingBlock) : p.theme.button.web.autoResize.paddingBlock;
});
var button = /*#__PURE__*/styled.button.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__button",
  componentId: "sc-1vj6sky-1"
})(["", ";", ";-webkit-appearance:none;text-decoration:none;outline:none;::-moz-focus-inner{border:none;}cursor:pointer;display:inline-flex;justify-content:center;", ";font-size:", ";font-weight:", ";border-radius:", ";position:relative;text-align:left;", "{", ";}", ";", ";"], fontFamilyStyles, buttonPaddings, function (p) {
  return p.$autoResize ? buttonResizeStyle : buttonFixedStyle;
}, themeVariant({
  normal: function normal(props) {
    return px2rem(props.theme.button.web.font.size[props.$size]);
  },
  condensed: function condensed(props) {
    return px2rem(props.theme.button.web.font.size.condensed);
  }
}), themeVariant({
  normal: function normal(props) {
    return props.theme.button.web.font.weight[props.$size];
  },
  condensed: function condensed(props) {
    return props.theme.button.web.font.weight.condensed;
  }
}), function (props) {
  return px2rem(props.theme.button.web.borders.radius);
}, text, buttonTextStyles, baseButtonStyles, boxStyles);

export { baseButtonStyles, button, buttonPaddings, buttonTextStyles, text };
